import React, {useState, useEffect} from 'react';
import pearson_logo from '../assets/pearson_logo.gif';


const ComingSoon = ({msgText="Page Unavailable!",content="Thank you for your interest in this simulation."}) => {
    const [currentYear, setCurrentYear] = useState(null);

    useEffect(() => {
        const getCurrentYear = () => {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            setCurrentYear(year);
        };
        getCurrentYear();
    },[]);

    return (
        <div className='comingsoon-container'>
            <div className='coming-soon'>
                <blockquote>
                    {
                        (msgText != "") && <p className='title'>{msgText}</p>
                    }
                    <p className='text'>{content}</p>
                </blockquote>
            </div>
            <br/>
            <div className='text'>
                <div className='ui table'>
                    <tbody>
                        <tr>
                            <td>
                                <a target='_blank' href="https://www.pearson.com/">
                                    <img src={pearson_logo} alt="Pearson Logo" />
                                </a>
                            </td>
                            <td>
                                <p className='copyright-text'>Copyright &copy; {currentYear} &nbsp;
                                    <a href="https://www.pearsoned.com/" target="_blank">Pearson Education</a>. All rights reserved.<br />
                                    <a target="_blank" href="https://www.pearsoned.com/terms-of-use/">Legal Notice</a>
                                    <a target="_blank" href="https://www.pearsoned.com/privacy-statement/">Privacy Policy</a>
                                    <a target="_blank" href="https://www.pearsoned.com/permissions/">Permissions</a>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </div>
            </div>
        </div>
    )
}

export default ComingSoon
